import { render, staticRenderFns } from "./AscCustomAlertsGrid.vue?vue&type=template&id=bff2c528&"
import script from "./AscCustomAlertsGrid.vue?vue&type=script&lang=js&"
export * from "./AscCustomAlertsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscCustomAlertsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports